// extracted by mini-css-extract-plugin
export default {"mainHeader":"StaffManagementMainHeader_mainHeader__TZwt+","dateBtn":"StaffManagementMainHeader_dateBtn__GJ+7-"};